import React from 'react'
import Layout from './layout'
import signupData from '../components/content/signup/signup.en-XC.yaml'
import Sign from '../templates/signupForm'
import Image from '../templates/Image'

export default function SignupThankYou() {
  return (
    <Layout title={signupData && signupData.title}>
      <div className="signup-wrapper">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signup-logo">
          <Image
            className="signup-img"
            border="0"
            src={signupData.content.img.url1}
            alt="Hero Icon"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 signup-content-desc">
              <h1>{signupData.content.title}</h1>
              <p>{signupData.content.description}</p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <Sign auto="true" />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
